import { reviewApi, AdminReviewsApi } from '~/Providers/Api';
import { success, error } from '~/Redux/Modules/Notifications';
import { parseErrors } from '~/Redux/Helpers';
import {
  FETCH_ALL,
  FETCH_ALL_FAILURE,
  FETCH_ALL_SUCCESS,
  FETCH_ONE,
  FETCH_ONE_SUCCESS,
  FETCH_ONE_FAILURE,
  CREATE,
  CREATE_SUCCESS,
  CREATE_FAILURE,
  UPDATE,
  UPDATE_SUCCESS,
  UPDATE_FAILURE,
  DELETE,
  DELETE_SUCCESS,
  DELETE_FAILURE,
} from './constants';

export const getReviews = (page = 1) => async dispatch => {
  dispatch({ type: FETCH_ALL });
  try {
    let response = await reviewApi.fetch(page);
    dispatch({ type: FETCH_ALL_SUCCESS, data: response.data });
    return response;
  } catch (err) {
    dispatch({ type: FETCH_ALL_FAILURE, error: err });
  }
};

export const getReview = reviewId => async dispatch => {
  dispatch({ type: FETCH_ONE });
  try {
    let response = await reviewApi.fetchOne(reviewId);
    dispatch({ type: FETCH_ONE_SUCCESS, data: response.data });
    return response;
  } catch (err) {
    dispatch({ type: FETCH_ONE_FAILURE, error: err });
  }
};

export const addReview = data => async dispatch => {
  dispatch({ type: CREATE });
  try {
    let response = await AdminReviewsApi.store({ ...data });
    dispatch({ type: CREATE_SUCCESS, data: response.data });
    dispatch(success('Review Added!'));
    return response;
  } catch (err) {
    dispatch({ type: CREATE_FAILURE, error: err });
    dispatch(error('Review not added', parseErrors(err)));
  }
};

export const updateReview = data => async dispatch => {
  dispatch({ type: UPDATE });
  try {
    let response = await AdminReviewsApi.update({ ...data });
    dispatch({ type: UPDATE_SUCCESS, data: response.data });
    dispatch(success('Review Updated!'));
    return response;
  } catch (err) {
    dispatch({ type: UPDATE_FAILURE, error: err });
    dispatch(error('Review not updated', parseErrors(err)));
  }
};

export const deleteReview = id => async dispatch => {
  dispatch({ type: DELETE, actionId: id });
  try {
    let response = await AdminReviewsApi.delete(id);
    dispatch({ type: DELETE_SUCCESS, data: response.data });
    dispatch(success('Review Deleted!'));
    return response;
  } catch (err) {
    dispatch({ type: DELETE_FAILURE, error: err });
  }
};
